import React from "react";
import { IconProps } from "./IconProps";

const CaretCircleLeftIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "32Light":
      return (
        <svg
          className="caret-circle"
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Background rect */}
          <rect
            className="bg"
            x="3"
            y="3"
            width="26"
            height="26"
            rx="13"
            fill="transparent"
          />
          <path
            d="M28.75 16C28.75 13.4783 28.0022 11.0132 26.6012 8.91648C25.2002 6.81976 23.209 5.18556 20.8792 4.22054C18.5495 3.25552 15.9859 3.00303 13.5126 3.49499C11.0393 3.98695 8.76751 5.20127 6.98439 6.98439C5.20127 8.76751 3.98695 11.0393 3.49499 13.5126C3.00302 15.9859 3.25552 18.5495 4.22053 20.8792C5.18555 23.209 6.81975 25.2003 8.91648 26.6012C11.0132 28.0022 13.4783 28.75 16 28.75C19.3803 28.746 22.621 27.4015 25.0112 25.0112C27.4015 22.621 28.746 19.3803 28.75 16ZM4.75 16C4.75 13.775 5.4098 11.5999 6.64597 9.74984C7.88213 7.89979 9.63914 6.45785 11.6948 5.60636C13.7505 4.75487 16.0125 4.53209 18.1948 4.96617C20.3771 5.40025 22.3816 6.47171 23.955 8.04505C25.5283 9.6184 26.5998 11.623 27.0338 13.8052C27.4679 15.9875 27.2451 18.2495 26.3936 20.3052C25.5422 22.3609 24.1002 24.1179 22.2502 25.354C20.4001 26.5902 18.225 27.25 16 27.25C13.0173 27.2467 10.1578 26.0604 8.0487 23.9513C5.93963 21.8422 4.75331 18.9827 4.75 16ZM18.53 21.53C18.3894 21.6705 18.1987 21.7493 18 21.7493C17.8012 21.7493 17.6106 21.6705 17.47 21.53L12.47 16.53C12.3295 16.3894 12.2507 16.1988 12.2507 16C12.2507 15.8013 12.3295 15.6106 12.47 15.47L17.47 10.47C17.6122 10.3375 17.8002 10.2654 17.9945 10.2688C18.1888 10.2723 18.3742 10.351 18.5116 10.4884C18.649 10.6258 18.7277 10.8112 18.7312 11.0055C18.7346 11.1998 18.6625 11.3878 18.53 11.53L14.0613 16L18.53 20.47C18.6704 20.6106 18.7493 20.8013 18.7493 21C18.7493 21.1988 18.6704 21.3894 18.53 21.53Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default CaretCircleLeftIcon;
